import { ActiveModel, ActiveField } from '@alt-point/active-models/src'

/**
* Class AttributeRequirementsBool
*  Настройки логического атрибута
*/
export class AttributeRequirementsBool extends ActiveModel {

  /**
  * type
  *   */
  @ActiveField({ readonly: true, value: () => 'Bool' })
  readonly type: string = 'Bool'
}
